import { formatEther } from 'ethers/lib/utils'
import { formatWhole } from '~shared/EtherInput'

export default function formatWei(amountWei, { decimalsLimit = 3 } = {}) {
    const [whole = '0', decimal = '0'] = formatEther(amountWei).toString().split('.')
    return `${formatWhole(whole, {
        stripLeadingZeros: true,
    })}.${`${decimal}${'000'.substr(0, Math.max(0, 3 - decimal.length))}`.substr(0, decimalsLimit)}`
}
